import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./showmap.css";
import {
  Upload,
  EditBusiness,
  AddBusiness,
  GetBusiness,
  GetBusinessCategories,
  GetProvinces,
  GetCityByProvinceId,
  GetAllUserTypes,
  AddUser,
  GetUser,
  EditUser,
  HasTell,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./user-list.styles.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nationCode: "0",
      flag: false,
      province: [],
      provinceId: null,
      name: "",
      nameHelper: "",
      desc: "",
      descHelper: "",
      imgUrl: "",
      mobile: "",
      mobileHelper: "",
      insta: "",
      latitude: 29.5926,
      longitude: 52.5836,
      website: "",
      userId: "",

      whatsapp: "",
      telegram: "",
      businessCategoryId: null,
      onlinePayCode: "",
      payType: null,
      tell: "",
      tellHelper: "",
      address: "",
      addressHelper: "",
      email: "",
      businessCode: "",
      cityId: null,
      userTypeId: null,
      permission: false,
      agent: false,
      cities: [],
      userTypes: [],
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      introducerCode: "",
      passWord: "",
      passwordHelper: "",
      oldTell: "",
      businessCategory: [],
      hasLocation: false,
      isActive: false,
      isConfirm: false,
    };
  }
  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };
  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    const L = require("leaflet");

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    if (this.props.match.params.id) {
      GetBusiness(this.props.match.params.id)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });

          this.setState({
            name: responseJson.name,
            desc: responseJson.desc,
            imgUrl: responseJson.imgUrl,
            mobile: responseJson.mobile,
            tell: responseJson.tell,
            insta: responseJson.insta,
            website: responseJson.website,
            whatsapp: responseJson.whatsapp,
            telegram: responseJson.telegram,
            address: responseJson.address,
            latitude: responseJson.latitude,
            longitude: responseJson.longitude,
            isActive: responseJson.isActive,
            // "IsActive": true,
            isConfirm: responseJson.isConfirm,
            businessCategoryId: responseJson.businessCategoryId,
            userId: responseJson.userId,

            // UserId: "a4210b9f-da22-4811-9f56-b5098542a6a3",
            cityId: responseJson.cityId,
            provinceId: responseJson.provinceId,
            // onlinePayCode: responseJson.onlinePayCode,
            // payType: responseJson.payType,
            // name: responseJson.name,
            // family: responseJson.family,
            // tell: responseJson.tell,
            // passWord: responseJson.passWord,
            // address: responseJson.address,
            // email: responseJson.email,
            // businessCode: responseJson.businessCode,
            // provinceId: responseJson.objCity.provinceId
            //   ? responseJson.objCity.provinceId
            //   : "",
            // cityId: responseJson.cityId,
            // userTypeId: responseJson.userTypeId,
            // permission: responseJson.permission,
            // agent: responseJson.agent,
            // nationCode: responseJson.nationCode,
            // introducerCode: responseJson.introducerCode,
          });
          this.getCitiesByProvince();
        })
        .catch((error) => {
          toast.error(error.message);
          console.error(error);
        });
    }

    GetProvinces(0, 999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    GetBusinessCategories(0, 999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ businessCategory: responseJson.query });
      })
      .catch((error) => {
        console.error(error);
      });

    GetAllUserTypes()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ userTypes: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  mapRef = createRef();
  handleClick = (e) => {
    this.state.longitude = e.latlng.lng;
    this.state.latitude = e.latlng.lat;
    this.setState({
      hasLocation: true,
    });

    const map = this.mapRef.current;
    if (map != null) {
      map.leafletElement.locate();
    }
  };

  handleLocationFound = (e) => {
    this.setState({
      hasLocation: true,
      longitude: e.latlng.lng,
      latitude: e.latlng.lat,
    });
  };

  handleSelectFile = (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })

      .then((responseJson) => {
        this.setState({ imgUrl: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  getCitiesByProvince = () => {
    // if (!this.props.match.params.productId) {
    GetCityByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  handleSave = () => {
    if (this.props.match.params.id) {
      EditBusiness({
        Name: this.state.name,
        Desc: this.state.desc,
        ImgUrl: this.state.imgUrl,
        Mobile: this.state.mobile,
        Tell: this.state.tell,
        Insta: this.state.insta,
        Website: this.state.website,
        Whatsapp: this.state.whatsapp,
        Telegram: this.state.telegram,
        Address: this.state.address,
        Latitude: this.state.latitude,
        Longitude: this.state.longitude,
        IsActive: this.state.isActive,
        IsConfirm: false,
        BusinessCategoryId: this.state.businessCategoryId,

        UserId: this.state.userId,
        CityId: this.state.cityId,
        ProvinceId: this.state.provinceId,
        // OnlinePayCode: this.state.onlinePayCode,
        // PayType: this.state.payType,
        Id: this.props.match.params.id,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای ویرایش شدن شغل");
          } else if (response.status === 200) {
            toast.success("شغل با موفقیت ویرایش شد");
            this.props.history.push("/main/business");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddBusiness({
        Name: this.state.name,
        Desc: this.state.desc,
        ImgUrl: this.state.imgUrl,
        Mobile: this.state.mobile,
        Tell: this.state.tell,
        Insta: this.state.insta,
        Website: this.state.website,
        Whatsapp: this.state.whatsapp,
        Telegram: this.state.telegram,
        Address: this.state.address,
        Latitude: this.state.latitude,
        Longitude: this.state.longitude,
        IsActive: this.state.isActive,
        IsConfirm: false,
        BusinessCategoryId: this.state.businessCategoryId,

        UserId: "a4210b9f-da22-4811-9f56-b5098542a6a3",
        CityId: this.state.cityId,
        ProvinceId: this.state.provinceId,
        // OnlinePayCode: this.state.onlinePayCode,
        // PayType: this.state.payType,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای اضافه کردن شغل");
          } else if (response.status === 200) {
            toast.success("شغل با موفقیت اضافه شد");

            this.props.history.push("/main/business");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }

        break;
      case "mobile":
        this.setState({ mobile: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ mobileHelper: "لطفاشماره موبایل  را وارد کنید" });
        } else {
          this.setState({ mobileHelper: "" });
        }

        break;
      case "tell":
        this.setState({ tell: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({ tellHelper: "لطفا شماره تماس را عدد وارد کنید" });
        } else {
          this.setState({ tellHelper: "" });
        }

        break;

        break;

      case "passWord":
        this.setState({ passWord: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            passwordHelper: "لطفا رمزعبور  را وارد کنید",
          });
        } else {
          this.setState({ passwordHelper: "" });
        }

        break;
      case "address":
        this.setState({ address: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ addressHelper: "لطفا آدرس  را وارد کنید" });
        } else {
          this.setState({ addressHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    const marker = this.state.hasLocation ? (
      <Marker position={this.state.latlng}>
        <Popup>You are here</Popup>
      </Marker>
    ) : null;
    const position = [this.state.latitude, this.state.longitude];
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.userId ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش شغل
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن شغل جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      value={this.state.name}
                      onChange={this.onchange}
                      id="name"
                      label="نام"
                      fullWidth
                      className={classes.textField}
                      // value={this.state.name}
                      margin="normal"
                      InputLabelProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.businessCategoryId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.businessCategoryId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="businessCategoryId"
                      select
                      label="دسته بندی شغل"
                      fullWidth
                      className={classes.textField}
                      value={this.state.businessCategoryId}
                      onChange={this.handleChange("businessCategoryId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.businessCategory &&
                        this.state.businessCategory.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      value={this.state.tell}
                      onChange={this.handleChange("tell")}
                      id="tell"
                      label="تلفن تماس"
                      fullWidth
                      className={classes.textField}
                      // value={this.state.tell}
                      margin="normal"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.mobile.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.mobile.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.mobileHelper.length !== 0}
                      helperText={this.state.mobileHelper}
                      value={this.state.mobile}
                      onChange={this.onchange}
                      id="mobile"
                      label="شماره موبایل"
                      fullWidth
                      className={classes.textField}
                      // value={this.state.mobile}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.address.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.address.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      error={this.state.addressHelper.length !== 0}
                      helperText={this.state.addressHelper}
                      value={this.state.address}
                      onChange={this.onchange}
                      id="address"
                      label="آدرس"
                      multiline
                      fullWidth
                      className={classes.textField}
                      // value={this.state.address}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      value={this.state.insta}
                      onChange={this.handleChange("insta")}
                      id="insta"
                      type="text"
                      label="اینستاگرام"
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      value={this.state.website}
                      onChange={this.handleChange("website")}
                      id="website"
                      type="text"
                      label="وبسایت"
                      fullWidth
                      className={classes.textField}
                      // value={this.state.passWord}
                      margin="normal"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      id="whatsapp"
                      label="واتزاپ"
                      fullWidth
                      className={classes.textField}
                      value={this.state.whatsapp}
                      onChange={this.handleChange("whatsapp")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      id="telegram"
                      label="تلگرام "
                      fullWidth
                      className={classes.textField}
                      value={this.state.telegram}
                      onChange={this.handleChange("telegram")}
                      margin="normal"
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={4}>
                    <TextField
                      id="nationCode"
                      label="کد پرداخت آنلاین"
                      fullWidth
                      className={classes.textField}
                      value={this.state.onlinePayCode}
                      onChange={this.handleChange("onlinePayCode")}
                      margin="normal"
                    />
                  </Grid> */}
                  {/* <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.payType === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.payType === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="payType"
                      select
                      fullWidth
                      label="نوع پرداخت"
                      className={classes.textField}
                      value={this.state.payType}
                      onChange={this.handleChange("payType")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      <MenuItem key={1} value={1}>
                        آنلاین
                      </MenuItem>
                      <MenuItem key={0} value={0}>
                        غیر آنلاین
                      </MenuItem>
                    </TextField>
                  </Grid> */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="standard-select-city"
                      select
                      label="استان"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.province &&
                        this.state.province.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name} - {option.province}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      InputLabelProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="standard-select-city"
                      select
                      label="شهر"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.cities &&
                        this.state.cities.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.isActive}
                        onChange={this.handleCheckChange("isActive")}
                        value="isActive"
                        color="primary"
                      />
                    }
                    label="فعال/غیر فعال "
                  />
                  {/* <Grid item xs={12} sm={6}>
                    <TextField
                      id="businessCategoryId"
                      select
                      label="دسته بندی شغل"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.businessCategoryId}
                      onChange={this.handleChange("businessCategoryId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.businessCategory &&
                        this.state.businessCategory.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid> */}
                  <Grid item xs={12} align={"right"}>
                    <div>
                      <input
                        accept="image/*"
                        className={classes.input}
                        style={{ display: "none" }}
                        id="raised-button-file"
                        multiple
                        type="file"
                        onChange={this.handleSelectFile}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          fullWidth
                          variant="contained"
                          component="span"
                          className={classes.button}
                        >
                          ارسال عکس
                        </Button>
                        {this.state.uploadPic && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </label>
                    </div>
                    <div>
                      <div className="picParent">
                        <img
                          src={`http://test.asa-oil.ir/${this.state.imgUrl}`}
                          className="picture"
                          alt={this.state.title}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="standard-description"
                      label="توضیحات"
                      fullWidth
                      multiline
                      rows="4"
                      className={classes.textField}
                      value={this.state.desc}
                      onChange={this.handleChange("desc")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Map
                      className="container"
                      center={position}
                      length={4}
                      onClick={(e) => this.handleClick(e)}
                      onLocationfound={(e) => this.handleLocationFound(e)}
                      // ref={mapRef}
                      zoom={13}
                    >
                      <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <Marker position={position}>
                        <Popup>`${position}`</Popup>
                      </Marker>
                    </Map>
                  </Grid>

                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.permission}
                        onChange={this.handleCheckChange("permission")}
                        value="permission"
                        color="primary"
                      />
                    }
                    label="سطح دسترسی"
                  /> */}
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.agent}
                        onChange={this.handleCheckChange("agent")}
                        value="agent"
                        color="primary"
                      />
                    }
                    label="نماینده"
                  /> */}
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        this.state.name.length === 0 ||
                        this.state.mobileHelper.length !== 0 ||
                        this.state.mobile.length === 0 ||
                        this.state.addressHelper.length !== 0 ||
                        this.state.address.length === 0 ||
                        this.state.provinceId === null ||
                        this.state.cityId === null ||
                        this.state.businessCategoryId === null
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
